export default __webpack_public_path__ + "static/media/globe.21d3274c.webp";